export enum ProductTypes {
  ProductOrService = 1,
  GiftCard = 2,
  PercentageVoucher = 3,
  ValueVoucher = 4,
}

export enum ProductLocationTypes {
  Online = 1,
  SpecificLocations = 2,
  OnlineAndSpecificLocations = 3,
}

export enum FilterTypes {
  OnlineStore = 89,
  PhysicalStore = 90,
}

export enum SoCodeTypes {
  Default = 1,
  Pin = 2,
}

export enum InvalidCodeReasons {
  AlreadyExisting = 1,
  CodeMaxLength = 2,
  PinMaxLength = 3,
  EmptyCode = 4,
  EmptyPin = 5,
}

export enum PercentageVoucherCodeTypes {
  RandomGenerated = 1,
  ManuallyAdded = 2,
}

export enum AddProductSteps {
  ProductType = 1,
  ProductDetails = 2,
  OfferDetails = 3,
  Translation = 4,
}

export enum CodeSourceTypes {
  ManuallyAdded = 1,
  Generated = 2,
}

export enum ProductActionTypes {
  SaveAsDraft = 1,
  SendForReview = 2,
  AddCodes = 3,
}

export enum MerchantAccountRoles {
  Admin = 1,
  Standard = 2,
}

export enum MerchantAccountStatus {
  PendingEmailConfirmation = 1,
  Active = 2,
  Inactive = 3,
}

export enum InformationTypes {
  PrivacyPolicy = 3,
  TermsAndConditions = 5,
}
